import { Deserializable } from '../deserializable';
import {Staffs} from '../staff/staffs';

export  class LogView implements Deserializable
{
  public id: number;
  public maVB: number;
  public typeView: string;
  public refId: number;
  public staffId: number;
  public thoiGianXemLanDau: Date;
  public thoiGianXemLanCuoi: Date;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
